import { createFileRoute } from "@tanstack/react-router";

import { AdminUsagePage } from "@/features/admin/usage/usage-page";
import { usageSearchSchema } from "@/features/admin/usage/search";
import { STATIC_LABELS } from "@/lib/nav-registry";

// ロールガードは親 layout (`admin/route.tsx`) が ADMIN 限定。
export const Route = createFileRoute("/_authenticated/admin/usage")({
  staticData: { crumb: { label: STATIC_LABELS.adminUsage } },
  // 集計期間・対象・一覧の絞り込みを URL に持つ（リロード・共有で消えない）。
  validateSearch: usageSearchSchema,
  component: AdminUsagePage,
});
